import { stopPropagationForHotKeysFromInput } from '@modules/taxonomy/helpers/stopEventPropagationForHotkeysFromInput';
import { TaxonomyActionType } from '@modules/taxonomy/store/taxonomyActionType';
import { useTaxonomyStore } from '@modules/taxonomy/store/taxonomyStore';
import {
  FormControl,
  FormHelperText,
  SxProps,
  TextField,
  Theme,
  Typography,
} from '@mui/material';
import { shallow } from 'zustand/shallow';
import { ReasonNameInputHelperText } from '../ReasonNameInputHelperText';

interface ReviewReasonNameProps {
  sxProps: SxProps<Theme>;
}

export const ReviewReasonName = ({ sxProps }: ReviewReasonNameProps) => {
  const dispatch = useTaxonomyStore(({ dispatch }) => dispatch);
  const { reasonName, reasonNameError } = useTaxonomyStore(
    ({ createReasonV3State: { reason, visual } }) => ({
      reasonName: reason?.name,
      reasonNameError: visual?.reasonNameError,
    }),
    shallow,
  );

  const onReasonNameChange = (reasonName: string) => {
    if (reasonNameError) {
      dispatch({
        type: TaxonomyActionType.SET_CREATE_REASONV3_STATE,
        payload: {
          visual: {
            reasonNameError: undefined,
          },
        },
      });
    }

    dispatch({
      type: TaxonomyActionType.SET_CREATE_REASONV3_STATE,
      payload: {
        reason: {
          name: reasonName,
        },
      },
    });
  };

  return (
    <FormControl>
      {reasonNameError && (
        <FormHelperText sx={{ mt: -3.25, ml: -0.1, pb: 1 }}>
          <Typography variant="caption" color="error">
            {reasonNameError}
          </Typography>
        </FormHelperText>
      )}
      <TextField
        type="text"
        size="small"
        label="Reason Name"
        variant="outlined"
        value={reasonName}
        onChange={(event) => onReasonNameChange(event.target.value)}
        sx={{
          minWidth: 400,
          ...sxProps,
        }}
        error={!!reasonNameError}
        onKeyDown={stopPropagationForHotKeysFromInput}
      />
      <ReasonNameInputHelperText />
    </FormControl>
  );
};
